import { render } from "./sel-tooltip.vue?vue&type=template&id=1deedd33&scoped=true"
import script from "./sel-tooltip.vue?vue&type=script&lang=js"
export * from "./sel-tooltip.vue?vue&type=script&lang=js"

import "./sel-tooltip.vue?vue&type=style&index=0&id=1deedd33&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1deedd33"]])

export default __exports__